import type { ISubjectCategoriesEnum } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IResponseOption } from "@/interfaces";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<ISubjectCategoriesEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.subjectCategories");

export const subjectCategories = {
  ...getAllApis,
};
